export { default as PaymentLoader } from './PaymentLoader';
